module.exports = __webpack_public_path__ + "static/media/microactions.a34f2857.svg";